// src/components/Admin/InserirLink.jsx
import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import Notification from '../Notification';
import LinkForm from './LinkForm'; // Importe o LinkForm


const InserirLink = () => {
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      await addDoc(collection(db, 'links'), formData);
      setNotification({
        message: 'Link adicionado com sucesso!',
        type: 'success',
      });
      // Limpa o formulário após o sucesso
      setTimeout(() => {
        setNotification(null);
        setLoading(false);
      }, 2000);
    } catch (error) {
      setNotification({
        message: 'Erro ao adicionar link: ' + error.message,
        type: 'error',
      });
      setLoading(false);
    }
  };

  return (
    <>
      <LinkForm
        onSubmit={handleSubmit}
        loading={loading}
        submitText="Adicionar Link"
      />
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </>
  );
};

export default InserirLink;